import { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'axios';

const Search = ({ searchEndpoint, setIsSearching, setHistory, setTotalCount }) => {
  const [search, setSearch] = useState('');

  const handleSearchChange = async (e) => {
    setIsSearching(true);

    const searchTerm = e.target.value;
    setSearch(searchTerm);

    const searchRes = await axios.get(searchEndpoint, {
      withCredentials: true,
      params: {
        term: searchTerm,
      },
    });

    setHistory(searchRes.data.data);
    setTotalCount(searchRes.data.totalRecords);
  };

  return (
    <>
      <div className="w-[602px] h-11 px-4 py-2 flex items-center gap-2.5 bg-core-black-contrast rounded-full border border-core-black-contrast-2 focus-within:border-core-grey-60 focus-within:ring-2 focus-within:ring-core-grey-60 focus-within:ring-opacity-20 transition-all duration-200">
        <div className="relative">
          <SearchIcon aria-hidden="true" className="text-core-black-contrast-3" />
        </div>
        <input
          type="text"
          placeholder="Search"
          value={search}
          onChange={handleSearchChange}
          className="w-full outline-none bg-transparent text-sm font-medium text-core-grey-80 placeholder-core-grey-80 focus:outline-none"
        />
      </div>
    </>
  );
};

export default Search;
